/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-20 07:47:45
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import PageTypeCollapse from './page-type-collapse';
import { RECOMMENDATION_WIDGET_PAGE_TYPES } from 'src/constants/recommendation';
import { RECOMMENDATION_TAB } from 'src/constants/translation';

type Props = {
  items: Array<Object>,
  locale: string,
  primaryLocale: string
};
type ComposedProps = Props & WithI18nProps;

class RecommendationTab extends Component<ComposedProps> {
  render() {
    const { i18n, locale, primaryLocale, items = {} } = this.props;

    // generate data to display UI from raw data (items)
    const displayPages = {};
    _.map(items, (pages, key) => {
      const displayItems = pages.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / 2);
        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []; // start a new chunk
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);
      displayPages[key] = displayItems;
    });

    return (
      <>
        {locale === primaryLocale ? (
          <div style={{ marginBottom: '1.25rem' }}>
            {i18n.translate(`AdminHTML.Translation.${RECOMMENDATION_TAB}.note`)}
          </div>
        ) : (
          <></>
        )}
        {_.map(Object.keys(RECOMMENDATION_WIDGET_PAGE_TYPES), (pageType, index) => (
          <PageTypeCollapse pageType={pageType} key={index}>
            <>
              {_.map(displayPages[pageType], (displayItem, index) => (
                <div key={index} className={index === 0 ? 'first' : ''}>
                  <Stack distribution="fill" wrap={true} alignment="trailing" key={index}>
                    <div>{!_.isEmpty(displayItem[0]) ? this.renderField(displayItem[0]) : ''}</div>
                    <div>{!_.isEmpty(displayItem[1]) ? this.renderField(displayItem[1]) : ''}</div>
                  </Stack>
                </div>
              ))}
              <br />
            </>
          </PageTypeCollapse>
        ))}
      </>
    );
  }

  renderField = (item: Object) => {
    const { locale, primaryLocale } = this.props;
    const disabled = locale === primaryLocale;
    return (
      <div>
        <Field
          name={`${locale}.${item.name}`}
          component={RenderTextField}
          label={item.label}
          placeholder={item.placeholder}
          anotherProps={{
            multiline: item.multiline,
            disabled: disabled // disable this field if primary language
          }}
        />
      </div>
    );
  };
}

export default withI18n()(RecommendationTab);
